import { BasePage as CngBasePage } from 'cng-web-lib'
import React from 'react'
import ViewPage from './ViewPage.js'
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap'
import ReTriggerSubmissionTranslationProvider from './contexts/ReTriggerSubmissionTranslationContext.js'

function WrappedViewPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <ReTriggerSubmissionTranslationProvider>
          <ViewPage showNotification={showSnackbar} {...props} />
        </ReTriggerSubmissionTranslationProvider>
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

export {
  WrappedViewPage as ViewPage
}
